<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>Send Email / App Notification to students</strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-radio-group v-model="radios" mandatory row class="no-display">
                    <v-radio label="Communicate With Students Standard Wise" value="select" color="#0f2027"></v-radio>
                    <v-radio label="Upload CSV For Student Communication" value="upload" color="#0f2027"></v-radio>
                    <v-radio label="Communicate With Employee" value="selectemp" color="#0f2027"></v-radio>
                    <!-- <v-radio label="Upload CSV For Employee Communication"  value="uploademp" color="#0f2027"></v-radio> -->
                </v-radio-group>
            </v-row>
            <v-row justify="center" dense v-if="radios == 'select'">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Academic Year"
                        outlined
                        @change="getStd()"
                        @click="putnull"
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="getDiv"
                        @click="putnull"
                        persistent-hint
                        hint="Please Select Standard"
                    />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list" item-text="div_name" label="Division" outlined @click="putnull" persistent-hint hint="Please Select  Division" />
                </v-col>

                <v-col sm="2" v-if="sel_ay_data && sel_std_data">
                    <v-btn class="mt-6 button" @click="getStudents()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="radios == 'upload'">
                <v-col sm="3" md="3" cols="12">
                    <v-avatar color="#E8EAF6"> 1</v-avatar>
                    <span style="margin-left: 10px; font-size: 15px; color: blue; text-decoration: underline; cursor: pointer;" @click="exportTableToCSV('Student_List')">
                        Download CSV / Excel Upload Template
                        <v-icon>mdi-download</v-icon>
                    </span>
                </v-col>
                <v-col sm="3" md="3" cols="12">
                    <v-file-input prepend-icon="mdi-file-excel" label="Select File" v-model="csvfile" accept=".csv" variant="underlined" show-size> </v-file-input>
                </v-col>
            </v-row>
            <v-row justify="center" dense v-if="radios == 'uploademp'">
                <v-col sm="3" md="3" cols="12">
                    <v-avatar color="#E8EAF6"> 1</v-avatar>
                    <span style="margin-left: 10px; font-size: 15px; color: blue; text-decoration: underline; cursor: pointer;" @click="exportTableToCSV_emp('Employee_List')">
                        Download CSV / Excel Upload Template
                        <v-icon>mdi-download</v-icon>
                    </span>
                </v-col>
                <v-col sm="3" md="3" cols="12">
                    <v-file-input prepend-icon="mdi-file-excel" label="Select File" v-model="csvfile" accept=".csv" variant="underlined" show-size> </v-file-input>
                </v-col>
            </v-row>
            <span v-if="mainList != '' && mainList != null && radios == 'select'">
                <v-card>
                    <v-card-title>
                        <v-col sm="3" v-if="mainList.length>0">
                            <v-autocomplete color="#0F2027" dense rounded v-model="selected_contact_type" :items="contact_type_list" item-text="name" item-value="id"  label="Please Select Contant Type" 
                             outlined persistent-hint hint="Message is send on selected contact type" />
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table show-select v-if="mainList.length > 0"  :key="selected_contact_type.id" :headers="dynamicHeaders" :items="mainList" :search="search" class="elevation-1" v-model="selected" item-key="ld_id">
                        <template v-slot:[`item.notification_token_present`]="{ item }">
                            <span v-if="item.notification_token_present">
                                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                            </span>
                            <span v-else>
                                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                            </span>
                        </template>
                    </v-data-table>
                </v-card>
            </span>

            <v-row justify="center" dense v-if="radios == 'selectemp'">
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="designation" :items="designation_list" item-text="name" item-value="id" label="Designation" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list" item-text="name" item-value="id" label="Employee" outlined />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" @click="getEmployee()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-card v-if="emp_list!=''">
                <v-data-table show-select v-if="emp_list!=''" :headers="headersemp" :items="emp_list" :search="search" class="elevation-1" v-model="selectedemp" item-key="inst_id">
                    <template v-slot:[`item.notification_token_present`]="{ item }">
                        <span v-if="item.notification_token_present">
                            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                        </span>
                        <span v-else>
                            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                        </span>
                    </template>
                </v-data-table>
            </v-card>

            <v-row class="justify-center">
                <v-btn v-if="selectedemp != '' && selectedemp != null && radios == 'selectemp'" class="button" :loading="fetch_loader" @click="nextpageemp(radios)">Compose</v-btn>
                 <v-btn v-if="selected != '' && radios == 'select'" class="button" :loading="fetch_loader" @click="nextpage(radios)">Compose</v-btn>
                <v-btn v-if="csvfile != null && radios == 'upload'" class="button" :loading="fetch_loader" @click="nextpage(radios)">Compose</v-btn>
            </v-row>
        </v-card>
        <v-card v-if="opencomposewindow == true">
            <v-row class="justify-center">
                <span v-if="radios == 'selectemp'">
                    <span v-for="(s,index) in sms_communication_values" :key="index">
                        <!-- <v-btn v-if="s.name == 'Guite Mail'" class="button" :loading="fetch_loader" @click="openEmailBox">Send Email <v-icon>mdi-email</v-icon></v-btn>
                        <v-btn v-if="s.name == 'AWS-Mail'" class="button" :loading="fetch_loader" @click="openEmailBox">Send AWS Mail <v-icon>mdi-email</v-icon></v-btn> -->
                        <v-btn v-if="s.name == 'JAVAMAIL'" class="button" :loading="fetch_loader" @click="openEmailBoxjava">Send JAVA Mail <v-icon>mdi-email</v-icon></v-btn>
                    </span>
                </span>
                <span v-else>
                    <span v-for="(s,index) in sms_communication_values" :key="index">
                        <v-btn v-if="s.name == 'Guite Mail'" class="button" :loading="fetch_loader" @click="openEmailBox">Send Email <v-icon>mdi-email</v-icon></v-btn>
                        <v-btn v-if="s.name == 'AWS-Mail'" class="button" :loading="fetch_loader" @click="openEmailBox">Send AWS Mail <v-icon>mdi-email</v-icon></v-btn>
                        <v-btn v-if="s.name == 'JAVAMAIL'" class="button" :loading="fetch_loader" @click="openEmailBoxjava">Send JAVA Mail <v-icon>mdi-email</v-icon></v-btn>
                        <v-btn v-if="s.name == 'App-notification'" class="button" :loading="fetch_loader" @click="openNotificationBox">Send App Notification <v-icon>mdi-message-badge</v-icon></v-btn>
                        <v-btn v-if="s.name == 'Whats-App'" class="button" :loading="fetch_loader" @click="openwpBox">Send Whatsapp Message <v-icon>mdi-whatsapp</v-icon></v-btn>
                        <v-btn v-if="s.name == 'SMS'" class="button" :loading="fetch_loader" @click="openSMSBox">Send SMS <v-icon>mdi-cellphone-message</v-icon></v-btn>
                        <v-btn v-if="s.name == 'Telegram'" class="button" :loading="fetch_loader" @click="openSMSBox">Send Telegram Message <v-icon>mdi-telegram</v-icon></v-btn>
                    </span>
                </span>
            </v-row>
        </v-card>
        <v-row class="justify-center">
            <v-dialog v-model="openemail" width="500px">
                <v-card>
                    <v-form>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Send Email</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field v-model="emailsubject" label="Enter Subject Name" persistent-hint></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea id="body" v-model="emailbody" label="Enter Body content" persistent-hint outlined></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue" outlined text @click="openemail = false">Cancel</v-btn>
                            <v-btn color="primary" v-if="radios == 'select'" dark @click="sendemail" :loading="fetch_loader">Send <v-icon>mdi-send</v-icon></v-btn>
                            <v-btn color="primary" v-if="radios == 'selectemp'" dark @click="sendMailEmp" :loading="fetch_loader">Send <v-icon>mdi-send</v-icon></v-btn>
                        </v-card-actions>
                    </v-form>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-dialog>
            <v-dialog v-model="openemailjava" width="500px">
                <v-card>
                    <v-form>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Send Email JAVA</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field v-model="emailsubject" label="Enter Subject Name" persistent-hint></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea id="body" v-model="emailbody" label="Enter Body content" persistent-hint outlined></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue" outlined text @click="openemailjava = false">Cancel</v-btn>
                            <v-btn color="primary" v-if="radios == 'select'" dark @click="sendemailjava" :loading="fetch_loader">Send <v-icon>mdi-send</v-icon></v-btn>
                            <v-btn color="primary" v-if="radios == 'selectemp'" dark @click="sendJavaMailEmp" :loading="fetch_loader">Send <v-icon>mdi-send</v-icon></v-btn>
                        </v-card-actions>
                    </v-form>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-dialog>
            <v-dialog v-model="notificationBox" width="500px">
                <v-card>
                    <v-form>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Send App Notification</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field v-model="notificationTitle" label="Enter Title" persistent-hint></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea v-model="notificationBody" label="Enter Body" persistent-hint outlined></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue" outlined text @click="notificationBox = false">Cancel</v-btn>
                            <v-btn color="primary" dark @click="sendMobileNotification" :loading="fetch_loader">Send Notification <v-icon>mdi-send</v-icon></v-btn>
                        </v-card-actions>
                    </v-form>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-dialog>
            <v-dialog v-model="faildailog" width="700px">
                <v-card>
                    <v-card-title>
                        <span>Following students have not received Email, please try again!</span>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table v-if="failed_mail_student_list.length > 0" :headers="headers2" :items="failed_mail_student_list" :search="search" class="elevation-1"> </v-data-table>
                    </v-card-text>
                    <v-row class="justify-center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" outlined text @click="faildailog = false">Cancel</v-btn>
                        </v-card-actions>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="faildailogemp" width="700px">
                <v-card>
                    <v-card-title>
                        <span>Following students have not received Email, please try again!</span>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table v-if="failed_mail_emp_list.length > 0" :headers="headers5" :items="failed_mail_student_list" :search="search" class="elevation-1"> </v-data-table>
                    </v-card-text>
                    <v-row class="justify-center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" outlined text @click="faildailogemp = false">Cancel</v-btn>
                        </v-card-actions>
                    </v-row>
                </v-card>
            </v-dialog>
            <v-dialog v-model="opensms" width="500px">
                <v-card>
                    <v-form>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Send SMS</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea id="body" v-model="smsbody" label="Enter Body content" persistent-hint outlined></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" outlined text @click="opensms = false">Cancel</v-btn>
                            <v-btn color="primary darken-1" dark @click="sendsms" :loading="fetch_loader">Send</v-btn>
                        </v-card-actions>
                    </v-form>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-dialog>
            <v-dialog v-model="openwp" width="800px">
                <v-card>
                    <v-form>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Send Message</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <!-- {{ whatsAppMessagingTemplates }} -->
                                    <v-col cols="12" sm="12" md="12">
                                        <v-autocomplete
                                            color="#0F2027"
                                            dense
                                            rounded
                                            required
                                            v-model="template"
                                            return-object
                                            :items="whatsAppMessagingTemplates"
                                            item-text="template_name"
                                            label="WhatsApp Template"
                                            outlined
                                            persistent-hint
                                            hint="Please Select Template"
                                        />
                                    </v-col>
                                    <v-col v-if="template" cols="12" sm="12" md="12">
                                        <v-textarea readonly auto-grow filled rows="5" v-model="template.template_data" label="Body content" persistent-hint outlined></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" outlined text @click="openwp = false">Cancel</v-btn>
                            <v-btn color="primary darken-1" dark @click="sendmsgwp" :loading="fetch_loader">Send</v-btn>
                        </v-card-actions>
                    </v-form>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </v-card>
            </v-dialog>
            <v-dialog v-model="failsmsdailog" width="700px">
                <v-card>
                    <v-card-title>
                        <span>Following students have not received SMS, please try again!</span>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table v-if="failed_sms_student_list.length > 0" :headers="headers3" :items="failed_sms_student_list" :search="search" class="elevation-1"> </v-data-table>
                    </v-card-text>
                    <v-row class="justify-center">
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" outlined text @click="failsmsdailog = false">Cancel</v-btn>
                        </v-card-actions>
                    </v-row>
                </v-card>
            </v-dialog>
            <table id="example" style="display: none; font-weight: bold;">
                <thead>
                    <tr>
                        <th class="mdl-data-table__cell--non-numeric">Registration Number</th>
                    </tr>
                </thead>
            </table>
            <table id="example1" style="display: none; font-weight: bold;">
                <thead>
                    <tr>
                        <th class="mdl-data-table__cell--non-numeric">Employee Code</th>
                    </tr>
                </thead>
            </table>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            Breadcrumbs,
        },
        data() {
            return {
                employee_type_list: [],
                employee_list: [],
                designation_list: [],
                employee_type: null,
                employee: null,
                designation: null,
                radios: null,
                csvfile: null,
                overlay: false,
                faildailog: false,
                faildailogemp: false,
                failsmsdailog: false,
                failed_mail_student_list: [],
                failed_sms_student_list: [],
                failed_mail_emp_list: [],
                smsbody: "",
                emailbody: "",
                emailsubject: "",
                openemail: false,
                opensms: false,
                openwp: false,
                template: null,
                opencomposewindow: false,
                fetch_loader: false,
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                selected_contact_type:"1",
                mainList: [],
                emp_list: [],
                selected: [],
                selectedemp: [],
                total_students: [],
                total_emp: [],
                sms_communication_values: [],
                headers1: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                    },
                    {
                        text: "PRN.",
                        align: "center",
                        value: "registration_number",
                    },
                    {
                        text: "Student Name",
                        align: "center",
                        value: "student_name",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        value: "standard",
                    },
                    {
                        text: "Division",
                        align: "center",
                        value: "division",
                    },
                    {
                        text: "Device Id?",
                        align: "center",
                        value: "notification_token_present",
                    },
                    {
                        text: "Email Id",
                        align: "center",
                        value: "email",
                    },
                    {
                        text: "Contact No.",
                        align: "center",
                        value: "contactno",
                    },
                ],
                headersemp: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                    },
                    {
                        text: "Employee Code",
                        align: "center",
                        value: "employee_code",
                    },
                    {
                        text: "Employee Name",
                        align: "center",
                        value: "employee_name",
                    },
                    {
                        text: "Email Id",
                        align: "center",
                        value: "email",
                    },
                    {
                        text: "Contact No.",
                        align: "center",
                        value: "contactno",
                    },
                    {
                        text: "Device Id?",
                        align: "center",
                        value: "notification_token_present",
                    },
                ],
                headers2: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                    },
                    {
                        text: "Student Name",
                        value: "student_name",
                    },
                ],
                headers5: [
                    {
                        text: "Sr. No.",
                        value: "srno",
                    },
                    {
                        text: "Employee Name",
                        value: "emp_name",
                    },
                ],
                headers3: [
                    {
                        text: "Sr. No.",
                        value: "sr_no",
                    },
                    {
                        text: "Student Name",
                        value: "student_name",
                    },
                ],
                notificationBox: false,
                notificationTitle: "",
                notificationBody: "",
                openemailjava: false,
                whatsAppMessagingTemplates: [],
                contact_type_list:[
                    {id: "1", name: "Contact Number"},
                    {id: "2", name: "Father Contact Number"},
                    {id: "3", name: "Mother Contact Number"},
                    {id: "4", name: "Emergency Contact Number"},
                ],
            };
        },
        computed:{
            dynamicHeaders() {
                let contactField = "contactno"
                let contactLabel = "Contact No."

                if (!this.selected_contact_type) {
                    return [
                        { text: "Sr. No.", value: "srno" },
                        { text: "PRN.", value: "registration_number" },
                        { text: "Student Name", value: "student_name" },
                        { text: "Standard", value: "standard" },
                        { text: "Division", value: "division" },
                        { text: "Device Id?", value: "notification_token_present" },
                        { text: "Email Id", value: "email" },
                        { text: contactLabel, value: contactField },
                    ]
                }

                if (this.selected_contact_type == "2") {
                    contactField = "father_contact_no"
                    contactLabel = "Father Contact No."
                } else if (this.selected_contact_type == "3") {
                    contactField = "mother_contact_no"
                    contactLabel = "Mother Contact No."
                } else if (this.selected_contact_type == "4") {
                    contactField = "emergency_contact_no"
                    contactLabel = "Emergency Contact No."
                } 

                return [
                    { text: "Sr. No.", value: "srno" },
                    { text: "PRN.", value: "registration_number" },
                    { text: "Student Name", value: "student_name" },
                    { text: "Standard", value: "standard" },
                    { text: "Division", value: "division" },
                    { text: "Device Id?", value: "notification_token_present" },
                    { text: "Email Id", value: "email" },
                    { text: contactLabel, value: contactField },
                ]
            }
        },
        methods: {
            // sendmsgwp() {
            //     if (this.template == null || this.template == "") {
            //         this.showSnackbar("#b71c1c", "Please select template"); // show snackbar
            //     }
            //     // const data = {
            //     //         body: this.template,
            //     //         students: this.total_students,
            //     //     };
            //     let formData = new FormData();
            //     if (this.radios == "upload" && this.csvfile != null) {
            //         formData.append("file", this.csvfile);
            //     }
            //     formData.append("body", JSON.stringify(this.template));
            //     for (var i = 0; i < this.total_students.length; i++) {
            //         // let learner = this.learner[i].lid;
            //         // formData.append("learner", learner);
            //         let learner = this.total_students[i];
            //         formData.append("students", learner);
            //     }
            //     formData.append("send_type", this.radios);
            //     formData.append('selected_contact_type',this.selected_contact_type)
            //     this.overlay = true;
            //     axios
            //         .post("/CommunicationType/sendWPMsg", formData)
            //         .then((res) => {
            //             this.overlay = false;
            //             this.openwp = false;
            //             this.fetch_loader = false;
            //             this.failed_sms_student_list = (res.data.failed_list || []).map((item, index) => ({
            //                 sr_no: index + 1,
            //                 ...item
            //             }));

            //             const successCount = res.data.success_list ? res.data.success_list.length : 0;
            //             const failedCount = this.failed_sms_student_list.length;

            //             if (successCount > 0 && failedCount == 0) {
            //                 // All successful
            //                 this.showSnackbar("success", "SMS has been sent successfully to all selected students.");

            //             } else if (successCount > 0 && failedCount > 0) {
            //                 // Partial success
            //                 this.showSnackbar("#ff9800",`${successCount} messages sent successfully, ${failedCount} failed.`);
            //                 this.failsmsdailog = true;

            //             } else if (successCount == 0 && failedCount > 0) {
            //                 // All failed
            //                 this.showSnackbar("#b71c1c","No messages were sent. Check if you have added contact details");
            //                 this.failsmsdailog = true;
            //             } else {
            //                 this.showSnackbar("#b71c1c", "No students were processed.");
            //             }
            //             // if (res.data.failed_list != null) {
            //             //     for (var i = 0; i < res.data.failed_list.length; i++) {
            //             //         this.failed_sms_student_list = res.data.failed_list;
            //             //     }
            //             //     this.showSnackbar("#ff5050", "Some student have not received SMS"); // show snackbar
            //             //     this.failsmsdailog = true;
            //             // }
            //         })
            //         .catch((error) => {
            //             // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            //             this.fetch_loader = false;
            //             this.overlay = false;
            //         })
            //         .finally(() => {
            //             this.fetch_loader = false;
            //             this.overlay = false;
            //             (this.total_students = []), (this.selected = []);
            //             this.opencomposewindow = false;
            //         });
            // },
            async sendmsgwp() {
                if (this.template == null || this.template == "") {
                    this.showSnackbar("#b71c1c", "Please select template");
                    return;
                }

                this.overlay = true;
                this.fetch_loader = true;

                try {
                    if (this.radios == "upload") {
                        if (this.csvfile == null) {
                            this.showSnackbar("#b71c1c", "Please select CSV file");
                            return;
                        }
                        let formData = new FormData();
                        formData.append("file", this.csvfile);
                        formData.append("body", JSON.stringify(this.template));
                        formData.append("send_type", this.radios);
                        formData.append("selected_contact_type", this.selected_contact_type);

                        const res = await axios.post("/CommunicationType/sendWPMsg", formData);
                        let successList = res.data.success_list || [];
                        let failedList = res.data.failed_list || [];

                        this.failed_sms_student_list = failedList.map((item, index) => ({
                            sr_no: index + 1,
                            ...item
                        }));

                        if (successList.length > 0 && failedList.length == 0) {
                            this.showSnackbar("success", successList.length + " messages sent successfully.");
                        } else if (successList.length > 0 && failedList.length > 0) {
                            this.showSnackbar("#ff9800", successList.length + " messages sent successfully, " + failedList.length + " failed");
                            this.failsmsdailog = true;
                        } else if (successList.length == 0 && failedList.length > 0) {
                            this.showSnackbar("#b71c1c","No messages were sent");
                            this.failsmsdailog = true;
                        } else {
                            this.showSnackbar("#b71c1c", "No students were processed");
                        }
                        this.openwp = false;
                        return;
                    }
                    const batchSize = 10;
                    let allSuccess = [];
                    let allFailed = [];

                    for (let i = 0; i < this.total_students.length; i += batchSize) {
                        let batch = this.total_students.slice(i, i + batchSize);

                        console.log("======================================");
                        console.log("BATCH START");
                        console.log("Batch Number:", Math.floor(i / batchSize) + 1);
                        console.log("Students in Batch:", batch.length);
                        console.log("Student IDs:", batch);
                        console.log("======================================");

                        let formData = new FormData();

                        formData.append("body", JSON.stringify(this.template));

                        for (let j = 0; j < batch.length; j++) {
                            formData.append("students", batch[j]);
                        }

                        formData.append("send_type", this.radios);
                        formData.append("selected_contact_type", this.selected_contact_type);

                        try {
                            const res = await axios.post(
                                "/CommunicationType/sendWPMsg",
                                formData
                            );

                            if (res.data.success_list != null) {
                                allSuccess = allSuccess.concat(res.data.success_list);
                            }

                            if (res.data.failed_list != null) {
                                allFailed = allFailed.concat(res.data.failed_list);
                            }

                            console.log("Batch " + (Math.floor(i / batchSize) + 1) + " completed");

                        } catch (error) {
                            console.log("Batch " + (Math.floor(i / batchSize) + 1) + " failed", error);

                            for (let j = 0; j < batch.length; j++) {
                                allFailed.push({
                                    student_name: "Student ID: " + batch[j],
                                    message: "Batch API failed"
                                });
                            }
                        }

                        await new Promise(resolve => setTimeout(resolve, 1000));
                    }

                    this.failed_sms_student_list = allFailed.map((item, index) => ({
                        sr_no: index + 1,
                        ...item
                    }));

                    if (allSuccess.length > 0 && allFailed.length == 0) {

                        this.showSnackbar(
                            "success",
                            allSuccess.length + " messages sent successfully."
                        );

                    } else if (allSuccess.length > 0 && allFailed.length > 0) {
                        this.showSnackbar("#ff9800",allSuccess.length + " messages sent successfully, " + allFailed.length +" failed");
                        this.failsmsdailog = true;
                    } else if (allSuccess.length == 0 && allFailed.length > 0) {
                        this.showSnackbar("#b71c1c","No messages were sent");
                        this.failsmsdailog = true;
                    } else {
                        this.showSnackbar("#b71c1c","No students were processed");
                    }

                    this.openwp = false;

                } catch (error) {
                    console.log("sendmsgwp error:", error);
                    this.showSnackbar("#b71c1c","Something went wrong while sending messages");
                } finally {
                    this.fetch_loader = false;
                    this.overlay = false;
                    this.total_students = [];
                    this.selected = [];
                    this.opencomposewindow = false;
                }
            },

            sendsms() {
                // console.log("inside sendemail");
                if (this.smsbody == null || this.smsbody == "") {
                    this.showSnackbar("#b71c1c", "Please add SMS Text!"); // show snackbar
                } else {
                    const data = {
                        body: this.smsbody,
                        students: this.total_students,
                        selected_contact_type: this.selected_contact_type
                    };
                    this.overlay = true;
                    axios
                        .post("/CommunicationType/sendSMS", data)
                        .then((res) => {
                            this.overlay = false;
                            this.opensms = false;
                            this.fetch_loader = false;
                            if (res.data.success_list != null) {
                                this.showSnackbar("success", "SMS has been sent successfully to all selected students..."); // show snackbar
                            }
                            if (res.data.failed_list != null) {
                                for (var i = 0; i < res.data.failed_list.length; i++) {
                                    this.failed_sms_student_list = res.data.failed_list;
                                }
                                this.showSnackbar("#ff5050", "Some student have not received SMS"); // show snackbar
                                this.failsmsdailog = true;
                            }
                        })
                        .catch((error) => {
                            // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            this.fetch_loader = false;
                            this.overlay = false;
                        })
                        .finally(() => {
                            this.fetch_loader = false;
                            this.overlay = false;
                            (this.total_students = []), (this.selected = []);
                        });
                }
            },
            sendMobileNotification() {
                // console.log("inside sendemail");
                if (this.notificationTitle == null || this.notificationTitle == "") {
                    this.showSnackbar("#b71c1c", "Please Add Notification Title!"); // show snackbar
                } else if (this.notificationBody == null || this.notificationBody == "") {
                    this.showSnackbar("#b71c1c", "Please Add Notification Body!"); // show snackbar
                } else {
                    const data = {
                        title: this.notificationTitle,
                        body: this.notificationBody,
                        students: this.total_students,
                    };
                    this.overlay = true;
                    this.fetch_loader = true;
                    axios
                        .post("/CommunicationType/sendMobileNotification", data)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                this.overlay = false;
                                this.notificationBox = false;
                                this.fetch_loader = false;
                                this.showSnackbar("success", "Notification has been sent successfully to all selected students..."); // show snackbar
                            } else if (res.data.status == "No") {
                                this.showSnackbar("#ff5050", res.data.status_reason); // show snackbar
                            }
                        })
                        .catch((error) => {
                            // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            this.fetch_loader = false;
                            this.overlay = false;
                        })
                        .finally(() => {
                            this.fetch_loader = false;
                            this.overlay = false;
                            (this.total_students = []), (this.selected = []), (this.notificationTitle = ""), (this.notificationBody = ""), (this.opencomposewindow = false), (this.notificationBox = false);
                        });
                }
            },
            sendemail() {
                // console.log("inside sendemail");
                if (this.emailsubject == null) {
                    this.showSnackbar("#b71c1c", "Please add email subject!"); // show snackbar
                } else if (this.emailbody == null) {
                    this.showSnackbar("#b71c1c", "Please add email body!"); // show snackbar
                } else {
                    const data = {
                        subject: this.emailsubject,
                        body: this.emailbody,
                        students: this.total_students,
                    };
                    this.overlay = true;
                    this.fetch_loader = true;
                    axios
                        .post("/CommunicationType/sendMail", data)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                this.overlay = false;
                                this.openemail = false;
                                this.fetch_loader = false;
                                if (res.data.success_list != null) {
                                    this.showSnackbar("success", "Email has been sent successfully to all selected students..."); // show snackbar
                                }
                                if (res.data.failed_list != null) {
                                    for (var i = 0; i < res.data.failed_list.length; i++) {
                                        this.failed_mail_student_list = res.data.failed_list;
                                    }
                                    this.showSnackbar("#ff5050", "Some student have not received mail"); // show snackbar
                                    this.faildailog = true;
                                }
                            } else if (res.data.status == "No") {
                                this.showSnackbar("#ff5050", res.data.status_reason); // show snackbar
                            }
                            // if (res.data.student_list.length != 0) {
                            //   this.mainList = res.data.student_list;
                            //   this.fetch_loader = false;
                            // } else {
                            //   this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
                            //   this.mainList = null;
                            //   this.fetch_loader = false;
                            // }
                        })
                        .catch((error) => {
                            // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            this.fetch_loader = false;
                            this.overlay = false;
                        })
                        .finally(() => {
                            this.fetch_loader = false;
                            this.overlay = false;
                            (this.total_students = []), (this.selected = []);
                        });
                }
            },
            sendMailEmp() {
                if (this.emailsubject == null) {
                    this.showSnackbar("#b71c1c", "Please add email subject!"); // show snackbar
                } else if (this.emailbody == null) {
                    this.showSnackbar("#b71c1c", "Please add email body!"); // show snackbar
                } else {
                    const data = {
                        subject: this.emailsubject,
                        body: this.emailbody,
                        emp: this.total_emp,
                    };
                    this.overlay = true;
                    this.fetch_loader = true;
                    axios
                        .post("/CommunicationType/sendMailEmp", data)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                this.overlay = false;
                                this.openemail = false;
                                this.fetch_loader = false;
                                if (res.data.success_list != null) {
                                    this.showSnackbar("success", "Email has been sent successfully to all selected students..."); // show snackbar
                                }
                                if (res.data.failed_list != null) {
                                    for (var i = 0; i < res.data.failed_list.length; i++) {
                                        this.failed_mail_emp_list = res.data.failed_list;
                                    }
                                    this.showSnackbar("#ff5050", "Some student have not received mail"); // show snackbar
                                    this.faildailogemp = true;
                                }
                            } else if (res.data.status == "No") {
                                this.showSnackbar("#ff5050", res.data.status_reason); // show snackbar
                            }
                        })
                        .catch((error) => {
                            // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            this.fetch_loader = false;
                            this.overlay = false;
                        })
                        .finally(() => {
                            this.fetch_loader = false;
                            this.overlay = false;
                            (this.total_emp = []), (this.selectedemp = []);
                        });
                }
            },
            sendJavaMailEmp() {
                if (this.emailsubject == null) {
                    this.showSnackbar("#b71c1c", "Please add email subject!"); // show snackbar
                } else if (this.emailbody == null) {
                    this.showSnackbar("#b71c1c", "Please add email body!"); // show snackbar
                } else {
                    const data = {
                        subject: this.emailsubject,
                        body: this.emailbody,
                        emp: this.total_emp,
                    };
                    this.overlay = true;
                    this.fetch_loader = true;
                    axios
                        .post("/CommunicationType/sendJavaMailEmp", data)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                this.overlay = false;
                                this.openemailjava = false;
                                this.fetch_loader = false;
                                if (res.data.success_list != null) {
                                    this.showSnackbar("success", "Email has been sent successfully to all selected students..."); // show snackbar
                                }
                                if (res.data.failed_list != null) {
                                    for (var i = 0; i < res.data.failed_list.length; i++) {
                                        this.failed_mail_emp_list = res.data.failed_list;
                                    }
                                    this.showSnackbar("#ff5050", "Some student have not received mail"); // show snackbar
                                    this.emp = true;
                                }
                            } else if (res.data.status == "No") {
                                this.showSnackbar("#ff5050", res.data.status_reason); // show snackbar
                            }
                        })
                        .catch((error) => {
                            // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            this.fetch_loader = false;
                            this.overlay = false;
                        })
                        .finally(() => {
                            this.fetch_loader = false;
                            this.overlay = false;
                            (this.total_emp = []), (this.selectedemp = []);
                        });
                }
            },
            sendemailjava() {
                if (this.emailsubject == null) {
                    this.showSnackbar("#b71c1c", "Please add email subject!"); // show snackbar
                } else if (this.emailbody == null) {
                    this.showSnackbar("#b71c1c", "Please add email body!"); // show snackbar
                } else {
                    const data = {
                        subject: this.emailsubject,
                        body: this.emailbody,
                        students: this.total_students,
                    };
                    this.overlay = true;
                    this.fetch_loader = true;
                    axios
                        .post("/CommunicationType/sendJavaMail", data)
                        .then((res) => {
                            if (res.data.status == "YES") {
                                this.overlay = false;
                                this.openemailjava = false;
                                this.fetch_loader = false;
                                if (res.data.success_list != null) {
                                    this.showSnackbar("success", "Email has been sent successfully to all selected students..."); // show snackbar
                                }
                                if (res.data.failed_list != null) {
                                    for (var i = 0; i < res.data.failed_list.length; i++) {
                                        this.failed_mail_student_list = res.data.failed_list;
                                    }
                                    this.showSnackbar("#ff5050", "Some student have not received mail"); // show snackbar
                                    this.faildailog = true;
                                }
                            } else if (res.data.status == "No") {
                                this.showSnackbar("#ff5050", res.data.status_reason); // show snackbar
                            }
                        })
                        .catch((error) => {
                            // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                            this.fetch_loader = false;
                            this.overlay = false;
                        })
                        .finally(() => {
                            this.fetch_loader = false;
                            this.overlay = false;
                            (this.total_students = []), (this.selected = []);
                        });
                }
            },

            openEmailBox() {
                // console.log("inside openEmailBox");
                this.openemail = true;
            },
            openEmailBoxjava() {
                // console.log("inside openEmailBox");
                this.openemailjava = true;
            },
            openNotificationBox() {
                // console.log("inside openEmailBox");
                this.notificationBox = true;
            },
            openSMSBox() {
                // console.log("inside openSMSBox");
                this.opensms = true;
            },
            openwpBox() {
                // console.log("inside openwpBox");
                this.openwp = true;
            },
            nextpage(radios) {
                if (radios == "select") {
                    this.total_students = [];
                    for (var i = 0; i < this.selected.length; i++) {
                        // console.log("selected" + this.selected[i].ld_id);
                        this.total_students.push(this.selected[i].ld_id);
                        // console.log("total_students: " + this.total_students.length);
                    }
                    if (this.total_students.length != 0) {
                        // alert("if....")
                        this.opencomposewindow = true;
                    } else {
                        this.opencomposewindow = false;
                        this.showSnackbar("#b71c1c", "Please select students!"); // show snackbar
                    }
                } else {
                    this.opencomposewindow = true;
                }
            },
            nextpageemp(radios) {
                if (radios == "selectemp") {
                    this.total_emp = [];
                    for (var i = 0; i < this.selectedemp.length; i++) {
                        // console.log("selected" + this.selected[i].ld_id);
                        this.total_emp.push(this.selectedemp[i].inst_id);
                        // console.log("total_students: " + this.total_students.length);
                    }
                    if (this.total_emp.length != 0) {
                        // alert("if....")
                        this.opencomposewindow = true;
                    } else {
                        this.opencomposewindow = false;
                        this.showSnackbar("#b71c1c", "Please select students!"); // show snackbar
                    }
                } else {
                    this.opencomposewindow = true;
                }
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = ["All"];
                this.sel_std_data = "All";
                this.std_div_list = this.sel_ay_data.std_list;
                this.std_div_list.unshift("All");
            },
            getDiv() {
                // console.log("inside getDiv"+this.sel_std_data)
                if (this.sel_std_data == "All") {
                    this.div_list = null;
                } else {
                    this.div_list = ["All"];
                    this.div = "All";
                    this.div_list = this.sel_std_data.div_list;
                    this.div_list.unshift("All");
                    this.div = this.div_list[0];
                    if (this.div_list.length == 0) {
                        alert("No division found!!!");
                        this.div_list = null;
                    }
                }
            },
            putnull() {
                this.mainList = [];
            },
            getEmployee() {
                const data = {
                    employee_type: this.employee_type,
                    designation: this.designation,
                    employee: this.employee,
                };
                this.fetch_loader = true;
                axios
                    .post("/CommunicationType/getEmployee", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.emp_list = res.data.inst_list;
                            this.fetch_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                        this.fetch_loader = false;
                    });
            },
            getStudents() {
                // console.log("this.div.div_id: "+this.div)
                // console.log("this.sel_std_data: "+this.sel_std_data)
                let formData;
                this.fetch_loader = true;
                let ay;
                let div;
                let standard;

                if (this.sel_std_data == "All") {
                    // console.log("inside this.div == null")
                    //"All" option in standard is selected
                    ay;
                    standard = this.sel_std_data;

                    if (this.sel_ay_data.ay_id) {
                        ay = this.sel_ay_data.ay_id;
                    } else if (this.sel_ay_data.id) {
                        ay = this.sel_ay_data.id;
                    }

                    formData = {
                        ay: ay,
                        standard: standard,
                    };
                    // console.log(": "+formData.ay)
                    // console.log(": "+formData.standard)
                } else {
                    //  console.log("inside particular standard and division is selected ")
                    //particular standard and division is selected
                    ay;
                    div = this.div.div_id;
                    standard = this.sel_std_data.std_id;

                    if (this.sel_ay_data.ay_id) {
                        ay = this.sel_ay_data.ay_id;
                    } else if (this.sel_ay_data.id) {
                        ay = this.sel_ay_data.id;
                    }
                    if (this.div.div_id) {
                        div = this.div.div_id;
                    } else {
                        div = this.div;
                    }

                    formData = {
                        ay: ay,
                        division: div,
                        standard: standard,
                    };
                    // console.log(": "+formData.ay)
                    // console.log(": "+formData.standard)
                    // console.log(": "+formData.division)
                }
                axios
                    .post("/CommunicationType/getStudents", formData)
                    .then((res) => {
                        if (res.data.student_list.length != 0) {
                            this.mainList = res.data.student_list;
                            this.sms_communication_values = res.data.sms_communication_values;
                            this.whatsAppMessagingTemplates = res.data.whatsAppMessagingTemplates;
                            this.fetch_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
                            this.mainList = null;
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        ay = null;
                        this.fetch_loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                        this.sms_communication_values = res.data.sms_communication_values;
                        this.whatsAppMessagingTemplates = res.data.whatsAppMessagingTemplates;
                        this.employee_type_list = res.data.employee_type_list;
                        this.employee_list = res.data.employee_list;
                        this.designation_list = res.data.designation_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            exportTableToCSV(filename) {
                //declare a JavaScript variable of array type
                var csv = [];
                var rows = document.querySelectorAll("#example  tr");
                var rows2 = document.getElementById("example");
                //merge the whole data in tabular form
                for (var i = 0; i < rows.length; i++) {
                    var row = [],
                        cols = rows[i].querySelectorAll("td, th");
                    for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);
                    csv.push(row.join(","));
                }
                //call the function to download the CSV file
                this.downloadCSV(csv.join("\n"), filename);
            },
            exportTableToCSV_emp(filename) {
                //declare a JavaScript variable of array type
                var csv = [];
                var rows = document.querySelectorAll("#example1  tr");
                var rows2 = document.getElementById("example");
                //merge the whole data in tabular form
                for (var i = 0; i < rows.length; i++) {
                    var row = [],
                        cols = rows[i].querySelectorAll("td, th");
                    for (var j = 0; j < cols.length; j++) row.push(cols[j].innerText);
                    csv.push(row.join(","));
                }
                //call the function to download the CSV file
                this.downloadCSV(csv.join("\n"), filename);
            },
            downloadCSV(csv, filename) {
                var csvFile;
                var downloadLink;

                //define the file type to text/csv
                csvFile = new Blob([csv], { type: "text/csv" });
                downloadLink = document.createElement("a");
                downloadLink.download = filename;
                downloadLink.href = window.URL.createObjectURL(csvFile);
                downloadLink.style.display = "none";

                document.body.appendChild(downloadLink);
                downloadLink.click();
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>

<style></style>
